import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { PRES, TYPE } from '../chrome';
import { COPY, originReviewBannerText } from '../presentationCopy';
import { OriginReview } from '../types';

interface OriginReviewBannerProps {
  review: OriginReview;
  onReveal: (slideId: string, objectId: string) => void;
}

const OriginReviewBanner: React.FC<OriginReviewBannerProps> = ({ review, onReveal }) => {
  if (!review.items.length) return null;
  const firstBox = review.items.find((item) => item.kind !== 'page');
  const first = firstBox || review.items[0];
  return (
    <Box sx={{ px: 1.5, pt: 1 }}>
      <Alert
        severity="warning"
        action={(
          <Button
            color="inherit"
            size="small"
            onClick={() => onReveal(first.slideId, first.objectId)}
            sx={{ textTransform: 'none' }}
          >
            {COPY.showBlock}
          </Button>
        )}
      >
        <Typography sx={{ fontFamily: TYPE.ui, ...TYPE.body, color: PRES.textPrimary }}>
          {originReviewBannerText(review.items, review.originalLanguage)}
        </Typography>
      </Alert>
    </Box>
  );
};

export default OriginReviewBanner;
